import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { GridRow, Column } from '../../common';

export default class Section1 extends Component {
  static propTypes = {
    hasContributionsToReport: PropTypes.bool,
    actions: PropTypes.object.isRequired,
  };

  static defaultProps = {
    hasContributionsToReport: false,
  };

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.hasContributionsToReport !== this.props.hasContributionsToReport
    );
  }

  render() {
    const { hasContributionsToReport, actions } = this.props;

    return (
      <GridRow>
        <Column sm={1} classNames="ms-textAlignRight">
          <h3 className="form-label">1</h3>
        </Column>
        <Column sm={11}>
          <ChoiceGroup
            selectedKey={hasContributionsToReport === false ? 'no' : 'yes'}
            onChange={actions.changeContributionsToReport}
            options={[
              {
                key: 'no',
                text: (
                  <Fragment>
                    <span>{'I have '}</span>
                    <strong>no</strong>
                    <span>{' contributions to report'}</span>
                  </Fragment>
                ),
              },
              {
                key: 'yes',
                text:
                  'I have the following contributions, including Common Source, to report:',
              },
            ]}
          />
        </Column>
      </GridRow>
    );
  }
}
